import { toHtml } from "@/lib/richtext";

/**
 * Рендер HTML из RichEditor админки. Класс .rich-content стилизован в globals.css
 * (абзацы, списки, заголовки, ссылки, выравнивание/цвета через инлайн-стили tiptap).
 */
export default function RichContent({ html, className, style }: { html?: string; className?: string; style?: React.CSSProperties }) {
  return (
    <div
      className={`rich-content${className ? " " + className : ""}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: toHtml(html) }}
    />
  );
}
